import {
  IonButton,
  IonContent,
  IonIcon,
  IonItem,
  IonList,
  IonListHeader,
  IonModal,
  IonPopover,
  IonText,
} from "@ionic/react";
import {
  barChartOutline,
  duplicateOutline,
  ellipsisVerticalOutline,
  megaphoneOutline,
} from "ionicons/icons";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setCreateStep } from "../../../store/massiveDocumentCreate";
import { fetchReportData } from "../../../store/documentList/actions/fetchReportData";
import { NotifySignersButton } from "./NotifySignersButton";
import { ReportModal } from "./ReportModal";

export const HelperActions: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });
  const dispatch = useDispatch();

  return (
    <>
      <IonButton onClick={() => setShowModal(true)}>
        <IonText>Acciones</IonText>
        <IonIcon slot="end" icon={ellipsisVerticalOutline} />
      </IonButton>
      <IonModal
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
        cssClass={"modal-fix-popover"}
      >
        <IonContent>
          <IonList>
            <IonListHeader>
              <h3>Acciones</h3>
            </IonListHeader>
            <NotifySignersButton />
            <IonItem
              button
              lines="none"
              onClick={() => {
                // setShowPopover({ showPopover: false, event: undefined });
                setShowModal(false);
                dispatch(fetchReportData());
              }}
            >
              <IonIcon icon={barChartOutline} slot="start" />
              <span>Reporte pendientes</span>
            </IonItem>

            <IonItem
              routerLink={`/app/rrhh/acuerdos/creacion-masiva`}
              button
              lines="none"
              onClick={() => {
                // setShowPopover({ showPopover: false, event: undefined });
                setShowModal(false);
              }}
            >
              <IonIcon icon={duplicateOutline} slot="start" />
              <span>Creación masiva</span>
            </IonItem>

            <IonItem
              routerLink={`/app/rrhh/acuerdos/notificacion-masiva`}
              button
              lines="none"
              onClick={() => {
                // setShowPopover({ showPopover: false, event: undefined });
                setShowModal(false);
              }}
            >
              <IonIcon icon={megaphoneOutline} slot="start" />
              <span>Notificación masiva</span>
            </IonItem>
          </IonList>
        </IonContent>
      </IonModal>
      {/* <IonButton
        id="size-button"
        onClick={(e: any) => {
          e.persist();
          setShowPopover({ showPopover: true, event: e });
        }}
      >
        <IonText>Acciones</IonText>
        <IonIcon slot="end" icon={ellipsisVerticalOutline} />
      </IonButton>

      <IonPopover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
      >
        <IonContent>
          <IonList>
            <IonListHeader>
              <h3>Acciones</h3>
            </IonListHeader>
            <NotifySignersButton />
            <IonItem
              button
              lines="none"
              onClick={() => {
                setShowPopover({ showPopover: false, event: undefined });
                dispatch(fetchReportData());
              }}
            >
              <IonIcon icon={barChartOutline} slot="start" />
              <span>Reporte pendientes</span>
            </IonItem>

            <IonItem
              routerLink={`/app/rrhh/acuerdos/creacion-masiva`}
              button
              lines="none"
              onClick={() => {
                setShowPopover({ showPopover: false, event: undefined });
              }}
            >
              <IonIcon icon={duplicateOutline} slot="start" />
              <span>Creación masiva</span>
            </IonItem>

            <IonItem
              routerLink={`/app/rrhh/acuerdos/notificacion-masiva`}
              button
              lines="none"
              onClick={() => {
                setShowPopover({ showPopover: false, event: undefined });
              }}
            >
              <IonIcon icon={megaphoneOutline} slot="start" />
              <span>Notificación masiva</span>
            </IonItem>
          </IonList>
        </IonContent>
      </IonPopover> */}

      <ReportModal />
    </>
  );
};
